import createReactComponent from '../createReactComponent';
var Copy = createReactComponent('Copy', [['rect', {
  x: '9',
  y: '9',
  width: '13',
  height: '13',
  rx: '2',
  ry: '2',
  key: '1ma1o8'
}], ['path', {
  d: 'M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1',
  key: '1t6kk3'
}]]);
export default Copy;